interface VideoEmbedProps {
  id: string;
  title: string;
  className?: string;
}

/** Responsive 16:9 YouTube embed. Tailwind `aspect-video` avoids needing an
 *  AspectRatio component (not present in this project's shadcn set). */
const VideoEmbed: React.FC<VideoEmbedProps> = ({ id, title, className = '' }) => (
  <div className={`relative w-full overflow-hidden rounded-lg aspect-video ${className}`}>
    <iframe
      className="absolute inset-0 h-full w-full"
      src={`https://www.youtube.com/embed/${id}`}
      title={title}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
    />
  </div>
);

export default VideoEmbed;
